import React from "react";
import PropTypes from 'prop-types';
import { Image } from "@sparefoot/react-commons";
import "./MediaContent.scss"
import VideoPlayer from "../VideoPlayer";


const MediaContent = ({ mediaType, url,title }) => {

    if (!["image","video"].includes(mediaType)) return null;

    return <>
        {mediaType === "image" && <Image className="rich-content-media" data-testid="media-image" src={url} alt="media content" />}
        {mediaType === "video" &&
            <div data-testid="media-video" className="youtube-player rich-content-media">
                <VideoPlayer url={url} title={title} />
            </div>
        }
    </>

}

export default MediaContent;

MediaContent.propTypes = {
    mediaType: PropTypes.oneOf(["image", "video"]).isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
}